module.exports = __webpack_public_path__ + "img/p1-gray.6547a4e6.png";